import React from "react";

export { default as Button, buttonClass } from "./Button";
export { Field, Input, Select, TextArea, fieldClass } from "./Field";

/** Перемикач-«пігулка» (категорії, бренди, моделі). */
export const Chip = ({ active, className = "", ...props }) => (
  <button
    type="button"
    className={`shrink-0 px-4 py-2 rounded-full border text-sm font-medium whitespace-nowrap transition ${
      active
        ? "bg-primary text-white border-blue-400 shadow-md shadow-primary/30"
        : "bg-slate-800/90 text-slate-200 border-slate-600 hover:border-slate-400"
    } ${className}`}
    {...props}
  />
);

/** Лічильник на іконці (кошик, обране). */
export const CountBadge = ({ count }) =>
  count > 0 ? (
    <span className="absolute -top-1.5 -right-2.5 min-w-[18px] h-[18px] px-1 bg-primary text-white text-[10px] font-bold rounded-full flex items-center justify-center ring-2 ring-[#101622]">
      {count}
    </span>
  ) : null;

export const Loader = ({ text = "Загрузка...", className = "" }) => (
  <div className={`flex items-center justify-center gap-3 py-10 text-slate-400 ${className}`}>
    <span className="w-5 h-5 rounded-full border-2 border-slate-600 border-t-primary animate-spin" />
    {text}
  </div>
);

/** Заголовок сторінки з необов'язковою дією праворуч. */
export const PageHeader = ({ title, action }) => (
  <header className="px-4 py-4 flex items-center justify-between gap-3">
    <h1 className="text-2xl font-bold text-white">{title}</h1>
    {action}
  </header>
);

/** Порожній стан: іконка, заголовок, текст, кнопка-дія. */
export const EmptyState = ({ icon: Icon, title, text, action }) => (
  <div className="flex flex-col items-center justify-center px-6 py-8 text-center">
    {Icon && (
      <div className="w-32 h-32 bg-primary/10 border border-primary/20 rounded-full flex items-center justify-center mb-6">
        <Icon className="w-16 h-16 text-blue-400/60" />
      </div>
    )}
    <h2 className="text-xl font-bold mb-2 text-white">{title}</h2>
    {text && <p className="text-slate-400 text-sm mb-8 max-w-xs">{text}</p>}
    {action}
  </div>
);

/** Картка-варіант для вибору (доставка, оплата). */
export const OptionCard = ({ selected, disabled, error, onSelect, className = "", children }) => (
  <div
    role="radio"
    aria-checked={!!selected}
    aria-disabled={!!disabled}
    tabIndex={disabled ? -1 : 0}
    onClick={() => !disabled && onSelect?.()}
    onKeyDown={(e) => {
      if (!disabled && (e.key === "Enter" || e.key === " ")) {
        e.preventDefault();
        onSelect?.();
      }
    }}
    className={`rounded-2xl border-2 p-4 transition outline-none focus-visible:ring-4 focus-visible:ring-primary/40 ${
      disabled
        ? "border-slate-800 bg-slate-900/40 opacity-50 cursor-not-allowed"
        : selected
        ? "border-primary bg-primary/15 shadow-lg shadow-primary/20 cursor-pointer"
        : error
        ? "border-red-500/70 bg-red-500/5 cursor-pointer"
        : "border-slate-600 bg-slate-900/70 hover:border-slate-400 cursor-pointer"
    } ${className}`}
  >
    {children}
  </div>
);

/** Радіо-кружечок для OptionCard. */
export const RadioDot = ({ selected }) => (
  <span
    className={`w-5 h-5 shrink-0 rounded-full border-2 flex items-center justify-center transition ${
      selected ? "border-primary" : "border-slate-500"
    }`}
  >
    {selected && <span className="w-2.5 h-2.5 rounded-full bg-primary" />}
  </span>
);

/** Кнопки − кількість + (картка товару, кошик). */
export const QuantityStepper = ({ quantity, onDecrease, onIncrease, size = "md" }) => {
  const btn =
    size === "sm"
      ? "w-8 h-8 rounded-lg text-base"
      : "w-10 h-10 rounded-xl text-lg";
  return (
    <div className="flex items-center gap-2 bg-slate-900/80 border border-slate-600 rounded-2xl p-1">
      <button
        type="button"
        aria-label="Уменьшить количество"
        onClick={onDecrease}
        className={`${btn} flex items-center justify-center font-bold bg-slate-700 text-white hover:bg-slate-600 active:scale-95 transition`}
      >
        −
      </button>
      <span className="min-w-[1.75rem] text-center font-bold text-white tabular-nums">{quantity}</span>
      <button
        type="button"
        aria-label="Увеличить количество"
        onClick={onIncrease}
        className={`${btn} flex items-center justify-center font-bold bg-primary text-white hover:bg-blue-500 active:scale-95 transition`}
      >
        +
      </button>
    </div>
  );
};
